module.exports = __webpack_public_path__ + "static/img/合作流程.c6fc9c2.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/合作流程.jpg
// module id = hDaN
// module chunks = 1